import { render, staticRenderFns } from "./VTextFieldColorPicker.vue?vue&type=template&id=31aa5a2d&scoped=true"
import script from "./VTextFieldColorPicker.vue?vue&type=script&lang=js"
export * from "./VTextFieldColorPicker.vue?vue&type=script&lang=js"
import style0 from "./VTextFieldColorPicker.vue?vue&type=style&index=0&id=31aa5a2d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31aa5a2d",
  null
  
)

export default component.exports